import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { Routes, rootRouteRef } from './routes';

export const explorePlugin = createPlugin({
  id: 'confidence-explore',
  routes: {
    ...Routes,
  },
});

export const ConfidenceExplorePage = explorePlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceExplorePage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-explore", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
